import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionStatusUnansweredIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1087 2.27302L16.8374 13.957C17.309 14.7802 16.6997 15.7965 15.7288 15.7965H2.27148C1.30058 15.7965 0.691261 14.7802 1.16287 13.957L7.8915 2.27302C8.37619 1.42983 9.62406 1.42983 10.1087 2.27302Z",
			fill: "#E6E6E6",
			stroke: "#344054",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.00005 14.4261C9.48953 14.4261 9.88633 14.0293 9.88633 13.5398C9.88633 13.0503 9.48953 12.6535 9.00005 12.6535C8.51057 12.6535 8.11377 13.0503 8.11377 13.5398C8.11377 14.0293 8.51057 14.4261 9.00005 14.4261Z",
			fill: "#344054"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.00006 5.7439V11.078",
			stroke: "#344054",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] })
});
export default SvgQuestionStatusUnansweredIcon;
